import { useRef, useState } from 'react';
import { Button } from '@/marketing/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/marketing/components/ui/dialog';

interface ConfirmScoutingDeclineDialogProps {
  creatorName: string;
  pending: boolean;
  error?: string;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

export function ConfirmScoutingDeclineDialog({
  creatorName,
  pending,
  error,
  onCancel,
  onConfirm,
}: ConfirmScoutingDeclineDialogProps) {
  const cancelButton = useRef<HTMLButtonElement>(null);
  const [reason, setReason] = useState('');
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open && !pending) {
          onCancel();
        }
      }}
    >
      <DialogContent
        className="ss-marketing"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          cancelButton.current?.focus();
        }}
      >
        <DialogHeader>
          <DialogTitle>Are you sure you want to decline this creator?</DialogTitle>
          <DialogDescription>
            <span className="tw-font-medium">{creatorName}</span> will be marked Rejected for this campaign.
          </DialogDescription>
        </DialogHeader>
        <label className="tw-space-y-1 tw-text-sm">
          <span>Reason (optional, internal only)</span>
          <textarea
            className="tw-min-h-24 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2"
            value={reason}
            maxLength={2000}
            disabled={pending}
            onChange={(event) => setReason(event.target.value)}
          />
        </label>
        {error && (
          <div role="alert" className="tw-space-y-1 tw-text-sm tw-text-red-700">
            <p>{error}</p>
            <p>If the creator changed, close this dialog and review the refreshed row before trying again.</p>
          </div>
        )}
        <DialogFooter>
          <Button ref={cancelButton} type="button" variant="outline" disabled={pending} onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" disabled={pending} onClick={() => onConfirm(reason)}>
            {pending ? 'Declining…' : 'Confirm decline'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
